import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=9348db78&scoped=true&"
import script from "./NotFound.vue?vue&type=script&lang=js&"
export * from "./NotFound.vue?vue&type=script&lang=js&"
import style0 from "./NotFound.vue?vue&type=style&index=0&id=9348db78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9348db78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/azureuser/wnytoys/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9348db78')) {
      api.createRecord('9348db78', component.options)
    } else {
      api.reload('9348db78', component.options)
    }
    module.hot.accept("./NotFound.vue?vue&type=template&id=9348db78&scoped=true&", function () {
      api.rerender('9348db78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client/app/components/NotFound.vue"
export default component.exports